import { Radio, Star, Video } from "lucide-react";

export function ExperiencePlatformTabs({ current }: { current: "tmall" | "douyin" | "kuaishou" }) {
  return (
    <nav className="experiencePlatformTabs" aria-label="店铺体验分平台">
      <a className={current === "tmall" ? "active" : ""} href="/#experience"><Star />天猫真实体验分</a>
      <a className={current === "douyin" ? "active douyin" : ""} href="/#experience-douyin"><Video />抖音商家体验分</a>
      <a className={current === "kuaishou" ? "active kuaishou" : ""} href="/#experience-kuaishou"><Radio />快手店铺体验分</a>
    </nav>
  );
}
